/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CatalogPackagesListParams,
  CatalogServicesListParams,
  PackageVersion,
  PaginatedServiceList,
  PaginatedServicePackageList,
  PatchedServicePackageRequest,
  PatchedServiceRequest,
  Service,
  ServicePackage,
  ServicePackageRequest,
  ServiceRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type catalogPackagesListResponse200 = {
  data: PaginatedServicePackageList
  status: 200
}
    
export type catalogPackagesListResponseSuccess = (catalogPackagesListResponse200) & {
  headers: Headers;
};
;

export type catalogPackagesListResponse = (catalogPackagesListResponseSuccess)

export const getCatalogPackagesListUrl = (params?: CatalogPackagesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/catalog/packages/?${stringifiedParams}` : `/api/v1/catalog/packages/`
}

export const catalogPackagesList = async (params?: CatalogPackagesListParams, options?: RequestInit): Promise<catalogPackagesListResponse> => {
  
  return apiFetch<catalogPackagesListResponse>(getCatalogPackagesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCatalogPackagesListQueryKey = (params?: CatalogPackagesListParams,) => {
    return [
    `/api/v1/catalog/packages/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCatalogPackagesListQueryOptions = <TData = Awaited<ReturnType<typeof catalogPackagesList>>, TError = unknown>(params?: CatalogPackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogPackagesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogPackagesList>>> = ({ signal }) => catalogPackagesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogPackagesListQueryResult = NonNullable<Awaited<ReturnType<typeof catalogPackagesList>>>
export type CatalogPackagesListQueryError = unknown


export function useCatalogPackagesList<TData = Awaited<ReturnType<typeof catalogPackagesList>>, TError = unknown>(
 params: undefined |  CatalogPackagesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogPackagesList>>,
          TError,
          Awaited<ReturnType<typeof catalogPackagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogPackagesList<TData = Awaited<ReturnType<typeof catalogPackagesList>>, TError = unknown>(
 params?: CatalogPackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogPackagesList>>,
          TError,
          Awaited<ReturnType<typeof catalogPackagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogPackagesList<TData = Awaited<ReturnType<typeof catalogPackagesList>>, TError = unknown>(
 params?: CatalogPackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCatalogPackagesList<TData = Awaited<ReturnType<typeof catalogPackagesList>>, TError = unknown>(
 params?: CatalogPackagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogPackagesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type catalogPackagesCreateResponse201 = {
  data: ServicePackage
  status: 201
}
    
export type catalogPackagesCreateResponseSuccess = (catalogPackagesCreateResponse201) & {
  headers: Headers;
};
;

export type catalogPackagesCreateResponse = (catalogPackagesCreateResponseSuccess)

export const getCatalogPackagesCreateUrl = () => {


  

  return `/api/v1/catalog/packages/`
}

export const catalogPackagesCreate = async (servicePackageRequest: ServicePackageRequest, options?: RequestInit): Promise<catalogPackagesCreateResponse> => {
  
  return apiFetch<catalogPackagesCreateResponse>(getCatalogPackagesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      servicePackageRequest,)
  }
);}




export const getCatalogPackagesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesCreate>>, TError,{data: ServicePackageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesCreate>>, TError,{data: ServicePackageRequest}, TContext> => {

const mutationKey = ['catalogPackagesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogPackagesCreate>>, {data: ServicePackageRequest}> = (props) => {
          const {data} = props ?? {};

          return  catalogPackagesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CatalogPackagesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof catalogPackagesCreate>>>
    export type CatalogPackagesCreateMutationBody = ServicePackageRequest
    export type CatalogPackagesCreateMutationError = unknown

    export const useCatalogPackagesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesCreate>>, TError,{data: ServicePackageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogPackagesCreate>>,
        TError,
        {data: ServicePackageRequest},
        TContext
      > => {

      const mutationOptions = getCatalogPackagesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type catalogPackagesRetrieveResponse200 = {
  data: ServicePackage
  status: 200
}
    
export type catalogPackagesRetrieveResponseSuccess = (catalogPackagesRetrieveResponse200) & {
  headers: Headers;
};
;

export type catalogPackagesRetrieveResponse = (catalogPackagesRetrieveResponseSuccess)

export const getCatalogPackagesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/catalog/packages/${id}/`
}

export const catalogPackagesRetrieve = async (id: string, options?: RequestInit): Promise<catalogPackagesRetrieveResponse> => {
  
  return apiFetch<catalogPackagesRetrieveResponse>(getCatalogPackagesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCatalogPackagesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/catalog/packages/${id}/`
    ] as const;
    }

    
export const getCatalogPackagesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof catalogPackagesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogPackagesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogPackagesRetrieve>>> = ({ signal }) => catalogPackagesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogPackagesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof catalogPackagesRetrieve>>>
export type CatalogPackagesRetrieveQueryError = unknown


export function useCatalogPackagesRetrieve<TData = Awaited<ReturnType<typeof catalogPackagesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogPackagesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof catalogPackagesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogPackagesRetrieve<TData = Awaited<ReturnType<typeof catalogPackagesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogPackagesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof catalogPackagesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogPackagesRetrieve<TData = Awaited<ReturnType<typeof catalogPackagesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCatalogPackagesRetrieve<TData = Awaited<ReturnType<typeof catalogPackagesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogPackagesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type catalogPackagesUpdateResponse200 = {
  data: ServicePackage
  status: 200
}
    
export type catalogPackagesUpdateResponseSuccess = (catalogPackagesUpdateResponse200) & {
  headers: Headers;
};
;

export type catalogPackagesUpdateResponse = (catalogPackagesUpdateResponseSuccess)

export const getCatalogPackagesUpdateUrl = (id: string,) => {


  

  return `/api/v1/catalog/packages/${id}/`
}

export const catalogPackagesUpdate = async (id: string,
    servicePackageRequest: ServicePackageRequest, options?: RequestInit): Promise<catalogPackagesUpdateResponse> => {
  
  return apiFetch<catalogPackagesUpdateResponse>(getCatalogPackagesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      servicePackageRequest,)
  }
);}




export const getCatalogPackagesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesUpdate>>, TError,{id: string;data: ServicePackageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesUpdate>>, TError,{id: string;data: ServicePackageRequest}, TContext> => {

const mutationKey = ['catalogPackagesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogPackagesUpdate>>, {id: string;data: ServicePackageRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogPackagesUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CatalogPackagesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof catalogPackagesUpdate>>>
    export type CatalogPackagesUpdateMutationBody = ServicePackageRequest
    export type CatalogPackagesUpdateMutationError = unknown

    export const useCatalogPackagesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesUpdate>>, TError,{id: string;data: ServicePackageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogPackagesUpdate>>,
        TError,
        {id: string;data: ServicePackageRequest},
        TContext
      > => {

      const mutationOptions = getCatalogPackagesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type catalogPackagesPartialUpdateResponse200 = {
  data: ServicePackage
  status: 200
}
    
export type catalogPackagesPartialUpdateResponseSuccess = (catalogPackagesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type catalogPackagesPartialUpdateResponse = (catalogPackagesPartialUpdateResponseSuccess)

export const getCatalogPackagesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/catalog/packages/${id}/`
}

export const catalogPackagesPartialUpdate = async (id: string,
    patchedServicePackageRequest: PatchedServicePackageRequest, options?: RequestInit): Promise<catalogPackagesPartialUpdateResponse> => {
  
  return apiFetch<catalogPackagesPartialUpdateResponse>(getCatalogPackagesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedServicePackageRequest,)
  }
);}




export const getCatalogPackagesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesPartialUpdate>>, TError,{id: string;data: PatchedServicePackageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesPartialUpdate>>, TError,{id: string;data: PatchedServicePackageRequest}, TContext> => {

const mutationKey = ['catalogPackagesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogPackagesPartialUpdate>>, {id: string;data: PatchedServicePackageRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogPackagesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CatalogPackagesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof catalogPackagesPartialUpdate>>>
    export type CatalogPackagesPartialUpdateMutationBody = PatchedServicePackageRequest
    export type CatalogPackagesPartialUpdateMutationError = unknown

    export const useCatalogPackagesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesPartialUpdate>>, TError,{id: string;data: PatchedServicePackageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogPackagesPartialUpdate>>,
        TError,
        {id: string;data: PatchedServicePackageRequest},
        TContext
      > => {

      const mutationOptions = getCatalogPackagesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type catalogPackagesDestroyResponse204 = {
  data: void
  status: 204
}
    
export type catalogPackagesDestroyResponseSuccess = (catalogPackagesDestroyResponse204) & {
  headers: Headers;
};
;

export type catalogPackagesDestroyResponse = (catalogPackagesDestroyResponseSuccess)

export const getCatalogPackagesDestroyUrl = (id: string,) => {


  

  return `/api/v1/catalog/packages/${id}/`
}

export const catalogPackagesDestroy = async (id: string, options?: RequestInit): Promise<catalogPackagesDestroyResponse> => {
  
  return apiFetch<catalogPackagesDestroyResponse>(getCatalogPackagesDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getCatalogPackagesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['catalogPackagesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogPackagesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  catalogPackagesDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CatalogPackagesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof catalogPackagesDestroy>>>
    
    export type CatalogPackagesDestroyMutationError = unknown

    export const useCatalogPackagesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogPackagesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCatalogPackagesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * No longer offered (history and existing contracts are kept).
 */
export type catalogPackagesArchiveCreateResponse200 = {
  data: ServicePackage
  status: 200
}
    
export type catalogPackagesArchiveCreateResponseSuccess = (catalogPackagesArchiveCreateResponse200) & {
  headers: Headers;
};
;

export type catalogPackagesArchiveCreateResponse = (catalogPackagesArchiveCreateResponseSuccess)

export const getCatalogPackagesArchiveCreateUrl = (id: string,) => {


  

  return `/api/v1/catalog/packages/${id}/archive/`
}

export const catalogPackagesArchiveCreate = async (id: string, options?: RequestInit): Promise<catalogPackagesArchiveCreateResponse> => {
  
  return apiFetch<catalogPackagesArchiveCreateResponse>(getCatalogPackagesArchiveCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getCatalogPackagesArchiveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesArchiveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesArchiveCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['catalogPackagesArchiveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogPackagesArchiveCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  catalogPackagesArchiveCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CatalogPackagesArchiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof catalogPackagesArchiveCreate>>>
    
    export type CatalogPackagesArchiveCreateMutationError = unknown

    export const useCatalogPackagesArchiveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesArchiveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogPackagesArchiveCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCatalogPackagesArchiveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Freeze a numbered version: from now on the AI, quotes and contracts use it.
 */
export type catalogPackagesPublishCreateResponse200 = {
  data: ServicePackage
  status: 200
}
    
export type catalogPackagesPublishCreateResponseSuccess = (catalogPackagesPublishCreateResponse200) & {
  headers: Headers;
};
;

export type catalogPackagesPublishCreateResponse = (catalogPackagesPublishCreateResponseSuccess)

export const getCatalogPackagesPublishCreateUrl = (id: string,) => {


  

  return `/api/v1/catalog/packages/${id}/publish/`
}

export const catalogPackagesPublishCreate = async (id: string, options?: RequestInit): Promise<catalogPackagesPublishCreateResponse> => {
  
  return apiFetch<catalogPackagesPublishCreateResponse>(getCatalogPackagesPublishCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getCatalogPackagesPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesPublishCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['catalogPackagesPublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogPackagesPublishCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  catalogPackagesPublishCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CatalogPackagesPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof catalogPackagesPublishCreate>>>
    
    export type CatalogPackagesPublishCreateMutationError = unknown

    export const useCatalogPackagesPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogPackagesPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogPackagesPublishCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCatalogPackagesPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type catalogPackagesVersionsListResponse200 = {
  data: PackageVersion[]
  status: 200
}
    
export type catalogPackagesVersionsListResponseSuccess = (catalogPackagesVersionsListResponse200) & {
  headers: Headers;
};
;

export type catalogPackagesVersionsListResponse = (catalogPackagesVersionsListResponseSuccess)

export const getCatalogPackagesVersionsListUrl = (id: string,) => {


  

  return `/api/v1/catalog/packages/${id}/versions/`
}

export const catalogPackagesVersionsList = async (id: string, options?: RequestInit): Promise<catalogPackagesVersionsListResponse> => {
  
  return apiFetch<catalogPackagesVersionsListResponse>(getCatalogPackagesVersionsListUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCatalogPackagesVersionsListQueryKey = (id?: string,) => {
    return [
    `/api/v1/catalog/packages/${id}/versions/`
    ] as const;
    }

    
export const getCatalogPackagesVersionsListQueryOptions = <TData = Awaited<ReturnType<typeof catalogPackagesVersionsList>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesVersionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogPackagesVersionsListQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogPackagesVersionsList>>> = ({ signal }) => catalogPackagesVersionsList(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesVersionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogPackagesVersionsListQueryResult = NonNullable<Awaited<ReturnType<typeof catalogPackagesVersionsList>>>
export type CatalogPackagesVersionsListQueryError = unknown


export function useCatalogPackagesVersionsList<TData = Awaited<ReturnType<typeof catalogPackagesVersionsList>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesVersionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogPackagesVersionsList>>,
          TError,
          Awaited<ReturnType<typeof catalogPackagesVersionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogPackagesVersionsList<TData = Awaited<ReturnType<typeof catalogPackagesVersionsList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesVersionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogPackagesVersionsList>>,
          TError,
          Awaited<ReturnType<typeof catalogPackagesVersionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogPackagesVersionsList<TData = Awaited<ReturnType<typeof catalogPackagesVersionsList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesVersionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCatalogPackagesVersionsList<TData = Awaited<ReturnType<typeof catalogPackagesVersionsList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogPackagesVersionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogPackagesVersionsListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type catalogServicesListResponse200 = {
  data: PaginatedServiceList
  status: 200
}
    
export type catalogServicesListResponseSuccess = (catalogServicesListResponse200) & {
  headers: Headers;
};
;

export type catalogServicesListResponse = (catalogServicesListResponseSuccess)

export const getCatalogServicesListUrl = (params?: CatalogServicesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/catalog/services/?${stringifiedParams}` : `/api/v1/catalog/services/`
}

export const catalogServicesList = async (params?: CatalogServicesListParams, options?: RequestInit): Promise<catalogServicesListResponse> => {
  
  return apiFetch<catalogServicesListResponse>(getCatalogServicesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCatalogServicesListQueryKey = (params?: CatalogServicesListParams,) => {
    return [
    `/api/v1/catalog/services/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCatalogServicesListQueryOptions = <TData = Awaited<ReturnType<typeof catalogServicesList>>, TError = unknown>(params?: CatalogServicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogServicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogServicesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogServicesList>>> = ({ signal }) => catalogServicesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogServicesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogServicesListQueryResult = NonNullable<Awaited<ReturnType<typeof catalogServicesList>>>
export type CatalogServicesListQueryError = unknown


export function useCatalogServicesList<TData = Awaited<ReturnType<typeof catalogServicesList>>, TError = unknown>(
 params: undefined |  CatalogServicesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogServicesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogServicesList>>,
          TError,
          Awaited<ReturnType<typeof catalogServicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogServicesList<TData = Awaited<ReturnType<typeof catalogServicesList>>, TError = unknown>(
 params?: CatalogServicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogServicesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogServicesList>>,
          TError,
          Awaited<ReturnType<typeof catalogServicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogServicesList<TData = Awaited<ReturnType<typeof catalogServicesList>>, TError = unknown>(
 params?: CatalogServicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogServicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCatalogServicesList<TData = Awaited<ReturnType<typeof catalogServicesList>>, TError = unknown>(
 params?: CatalogServicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogServicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogServicesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type catalogServicesCreateResponse201 = {
  data: Service
  status: 201
}
    
export type catalogServicesCreateResponseSuccess = (catalogServicesCreateResponse201) & {
  headers: Headers;
};
;

export type catalogServicesCreateResponse = (catalogServicesCreateResponseSuccess)

export const getCatalogServicesCreateUrl = () => {


  

  return `/api/v1/catalog/services/`
}

export const catalogServicesCreate = async (serviceRequest: ServiceRequest, options?: RequestInit): Promise<catalogServicesCreateResponse> => {
  
  return apiFetch<catalogServicesCreateResponse>(getCatalogServicesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      serviceRequest,)
  }
);}




export const getCatalogServicesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogServicesCreate>>, TError,{data: ServiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogServicesCreate>>, TError,{data: ServiceRequest}, TContext> => {

const mutationKey = ['catalogServicesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogServicesCreate>>, {data: ServiceRequest}> = (props) => {
          const {data} = props ?? {};

          return  catalogServicesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CatalogServicesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof catalogServicesCreate>>>
    export type CatalogServicesCreateMutationBody = ServiceRequest
    export type CatalogServicesCreateMutationError = unknown

    export const useCatalogServicesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogServicesCreate>>, TError,{data: ServiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogServicesCreate>>,
        TError,
        {data: ServiceRequest},
        TContext
      > => {

      const mutationOptions = getCatalogServicesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type catalogServicesRetrieveResponse200 = {
  data: Service
  status: 200
}
    
export type catalogServicesRetrieveResponseSuccess = (catalogServicesRetrieveResponse200) & {
  headers: Headers;
};
;

export type catalogServicesRetrieveResponse = (catalogServicesRetrieveResponseSuccess)

export const getCatalogServicesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/catalog/services/${id}/`
}

export const catalogServicesRetrieve = async (id: string, options?: RequestInit): Promise<catalogServicesRetrieveResponse> => {
  
  return apiFetch<catalogServicesRetrieveResponse>(getCatalogServicesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCatalogServicesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/catalog/services/${id}/`
    ] as const;
    }

    
export const getCatalogServicesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof catalogServicesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogServicesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogServicesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogServicesRetrieve>>> = ({ signal }) => catalogServicesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogServicesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogServicesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof catalogServicesRetrieve>>>
export type CatalogServicesRetrieveQueryError = unknown


export function useCatalogServicesRetrieve<TData = Awaited<ReturnType<typeof catalogServicesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogServicesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogServicesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof catalogServicesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogServicesRetrieve<TData = Awaited<ReturnType<typeof catalogServicesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogServicesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogServicesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof catalogServicesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogServicesRetrieve<TData = Awaited<ReturnType<typeof catalogServicesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogServicesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCatalogServicesRetrieve<TData = Awaited<ReturnType<typeof catalogServicesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogServicesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogServicesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type catalogServicesUpdateResponse200 = {
  data: Service
  status: 200
}
    
export type catalogServicesUpdateResponseSuccess = (catalogServicesUpdateResponse200) & {
  headers: Headers;
};
;

export type catalogServicesUpdateResponse = (catalogServicesUpdateResponseSuccess)

export const getCatalogServicesUpdateUrl = (id: string,) => {


  

  return `/api/v1/catalog/services/${id}/`
}

export const catalogServicesUpdate = async (id: string,
    serviceRequest: ServiceRequest, options?: RequestInit): Promise<catalogServicesUpdateResponse> => {
  
  return apiFetch<catalogServicesUpdateResponse>(getCatalogServicesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      serviceRequest,)
  }
);}




export const getCatalogServicesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogServicesUpdate>>, TError,{id: string;data: ServiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogServicesUpdate>>, TError,{id: string;data: ServiceRequest}, TContext> => {

const mutationKey = ['catalogServicesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogServicesUpdate>>, {id: string;data: ServiceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogServicesUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CatalogServicesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof catalogServicesUpdate>>>
    export type CatalogServicesUpdateMutationBody = ServiceRequest
    export type CatalogServicesUpdateMutationError = unknown

    export const useCatalogServicesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogServicesUpdate>>, TError,{id: string;data: ServiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogServicesUpdate>>,
        TError,
        {id: string;data: ServiceRequest},
        TContext
      > => {

      const mutationOptions = getCatalogServicesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type catalogServicesPartialUpdateResponse200 = {
  data: Service
  status: 200
}
    
export type catalogServicesPartialUpdateResponseSuccess = (catalogServicesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type catalogServicesPartialUpdateResponse = (catalogServicesPartialUpdateResponseSuccess)

export const getCatalogServicesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/catalog/services/${id}/`
}

export const catalogServicesPartialUpdate = async (id: string,
    patchedServiceRequest: PatchedServiceRequest, options?: RequestInit): Promise<catalogServicesPartialUpdateResponse> => {
  
  return apiFetch<catalogServicesPartialUpdateResponse>(getCatalogServicesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedServiceRequest,)
  }
);}




export const getCatalogServicesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogServicesPartialUpdate>>, TError,{id: string;data: PatchedServiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogServicesPartialUpdate>>, TError,{id: string;data: PatchedServiceRequest}, TContext> => {

const mutationKey = ['catalogServicesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogServicesPartialUpdate>>, {id: string;data: PatchedServiceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogServicesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CatalogServicesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof catalogServicesPartialUpdate>>>
    export type CatalogServicesPartialUpdateMutationBody = PatchedServiceRequest
    export type CatalogServicesPartialUpdateMutationError = unknown

    export const useCatalogServicesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogServicesPartialUpdate>>, TError,{id: string;data: PatchedServiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogServicesPartialUpdate>>,
        TError,
        {id: string;data: PatchedServiceRequest},
        TContext
      > => {

      const mutationOptions = getCatalogServicesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type catalogServicesDestroyResponse204 = {
  data: void
  status: 204
}
    
export type catalogServicesDestroyResponseSuccess = (catalogServicesDestroyResponse204) & {
  headers: Headers;
};
;

export type catalogServicesDestroyResponse = (catalogServicesDestroyResponseSuccess)

export const getCatalogServicesDestroyUrl = (id: string,) => {


  

  return `/api/v1/catalog/services/${id}/`
}

export const catalogServicesDestroy = async (id: string, options?: RequestInit): Promise<catalogServicesDestroyResponse> => {
  
  return apiFetch<catalogServicesDestroyResponse>(getCatalogServicesDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getCatalogServicesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogServicesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogServicesDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['catalogServicesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogServicesDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  catalogServicesDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CatalogServicesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof catalogServicesDestroy>>>
    
    export type CatalogServicesDestroyMutationError = unknown

    export const useCatalogServicesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogServicesDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogServicesDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCatalogServicesDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    